const principles = [
  { icon: "ri-shield-check-line", text: "保持 100% 透明" },
  { icon: "ri-hand-heart-line", text: "不收取任何前期費用" },
  { icon: "ri-percent-line", text: "只在成功撮合後收取合理 carry" },
];

export default function WhoIAmSection() {
  return (
    <section id="who-i-am" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-xl overflow-hidden w-full h-[480px]">
              <img
                src="https://static.readdy.ai/image/76f94b045f9b93f74f066d244037d990/a94c161c1d56b9559469666d97bbc25b.jpeg"
                alt="Ecosystem Scout"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 bg-amber-600 text-white rounded-xl px-5 py-4 shadow-lg">
              <p className="text-2xl font-bold">500+</p>
              <p className="text-xs text-amber-100 mt-0.5">AI 初創接觸</p>
            </div>
          </div>

          {/* Text side */}
          <div className="order-1 lg:order-2">
            <p className="text-amber-600 text-sm font-semibold tracking-widest uppercase mb-3">About Me</p>
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6 leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              我是誰？
            </h2>
            <p className="text-stone-600 text-base leading-relaxed mb-4">
              我是 Dickson Yue，一位專注香港AI生態的 Ecosystem Scout。
            </p>
            <p className="text-stone-600 text-base leading-relaxed mb-8">
              我目前全力投入香港AI創業圈，經常出沒於 Cyberport 和 HKSTP，參加各類工作坊、Demo Day 與創辦人交流。我不是基金，也沒有自己的資金，我扮演「眼睛與橋樑」的角色 —— 把真正有潛力的早期 AI 項目，介紹給有長期視野的家族辦公室與策略投資人。
            </p>

            {/* Principles */}
            <div className="space-y-3">
              <p className="text-stone-800 font-semibold text-sm mb-4">我的原則非常簡單：</p>
              {principles.map((p) => (
                <div key={p.text} className="flex items-center gap-3 bg-stone-50 rounded-lg px-4 py-3">
                  <div className="w-8 h-8 flex items-center justify-center text-amber-600">
                    <i className={`${p.icon} text-lg`} />
                  </div>
                  <span className="text-stone-700 text-sm font-medium">{p.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
